import { scopedTranslation } from '@utils/I18n'

import { DetailRow } from './GroupDetailsPanel'

const t = scopedTranslation('components')
const tShared = scopedTranslation('shared')

type PointPeopleProps = {
  notifyAllAdmins: boolean
  pointPersonEmails: string[]
}

const PointPeople = ({ notifyAllAdmins, pointPersonEmails }: PointPeopleProps) => {
  const value = notifyAllAdmins ? t('group_card.labels.all_admins') : pointPersonEmails.join(', ')

  return (
    <DetailRow icon="bell-01" label={t('group_card.labels.point_people')} testId="point-people">
      {value || <span className="tw:italic tw:text-gray-true-500">{tShared('labels.none')}</span>}
    </DetailRow>
  )
}

export default PointPeople
